import CampaignRoutes from "@forwardflow/router/CampaignRoutes";
const CampaignLayout = () => {
  return (
    <>
      <CampaignRoutes />
    </>
  );
};

export default CampaignLayout;
